import { render } from "./HomeArticleDetail.vue?vue&type=template&id=7d937870&scoped=true"
import script from "./HomeArticleDetail.vue?vue&type=script&lang=js"
export * from "./HomeArticleDetail.vue?vue&type=script&lang=js"

import "@/components/home/home-public/middle.css?vue&type=style&index=0&id=7d937870&scoped=true&lang=css&external"
import "@/components/home/home-public/article-details.css?vue&type=style&index=1&id=7d937870&scoped=true&lang=css&external"
import "./homearticledetail-responsive.css?vue&type=style&index=2&id=7d937870&scoped=true&lang=css&external"
import "./public-news-responsive.css?vue&type=style&index=3&id=7d937870&scoped=true&lang=css&external"
import "./HomeArticleDetail.vue?vue&type=style&index=4&id=7d937870&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d937870"]])

export default __exports__